<div class="open-tile-detail-container" [ngClass]="setContainerClasses()" (click)="triggerAction()">
  
  <a [href]="componentDetails?.settings?.action?.url" *ngIf="componentDetails?.settings?.action?.url; else openTileDetail" [attr.download]="componentDetails?.settings?.action?.type === 'download' ? '' : null">
    <ng-container *ngTemplateOutlet="openTileDetail"></ng-container>
  </a>

  <ng-template #openTileDetail>
    <div class="open-tile-detail">

      <div class="open-tile-detail-icon" *ngIf="componentDetails?.settings?.iconUrl || componentDetails?.settings?.iconName">
        <ng-container *ngIf="componentDetails?.settings?.iconUrl">
          <img [src]="componentDetails.settings.iconUrl" />
        </ng-container>
        <ng-container *ngIf="componentDetails?.settings?.iconName">
          <open-svg-icon [name]="componentDetails?.settings?.iconName" [class]="componentDetails?.settings?.iconClass"></open-svg-icon>
        </ng-container>
      </div>

      <strong class="open-tile-detail-heading" *ngIf="componentDetails?.settings?.title" [innerHtml]="componentDetails.settings.title"></strong>

      <div class="open-tile-detail-content" *ngIf="componentDetails?.settings?.content" [innerHtml]="componentDetails.settings.content"></div>
      
      <ng-container [ngSwitch]="componentDetails?.settings?.action?.type">
        <div *ngSwitchCase="'help'" class="open-tile-detail-cta">
          <strong>{{ componentDetails?.settings?.action?.text }}</strong>
          <open-tooltip [tooltipIcon]="componentDetails?.settings?.action?.icon" [tooltipContent]="componentDetails?.settings?.action?.content"></open-tooltip>
        </div>        
        <div *ngSwitchDefault class="open-tile-detail-cta">
          <strong>{{ componentDetails?.settings?.action?.text }}</strong>
          <mat-icon [ngClass]="componentDetails?.settings?.action?.icon" aria-hidden="false" [attr.aria-label]="componentDetails?.settings?.action?.text"></mat-icon>
        </div>
      </ng-container> 

    </div>
  </ng-template>

</div>
